import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Config } from 'src/app/shared/models/config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public config!: Config;
  private configGlobal = new BehaviorSubject<any>({});
  readonly configGlobalValue = this.configGlobal.asObservable();

  load(): Observable<any> {
    const data = environment;

    sessionStorage.setItem('globalConfig', JSON.stringify(data));
    this.setConfigGlobal(data);

    return of(true);
  }

  setConfigGlobal(value: any) {
    return this.configGlobal.next(value);
  }
}
